import { ActionAny, createActions } from 'src/utils/createActions';
import { CrawlerTask } from 'src/types/entities/CrawlerTask';

export type ManualCrawlerAbortActions =
    ActionAny<null, CrawlerTask>;
export const MANUAL_CRAWLER_ABORT_ACTIONS =
    createActions<null, CrawlerTask>('MANUAL_CRAWLER_ABORT');
